import * as React from 'react';

import { EActionType } from '../../../../../../../shared/repositories/search-offers.legacy/v2/types/dailyrentData';
import { useIsDailyrentOnlineBookingEnabled } from '../../../../../../../shared/utils/featureToggles/useIsDailyrentOnlineBookingEnabled';
import { DailyrentActionsLayout } from '../../../../components/DailyrentActionsLayout';
import { useOfferContext } from '../../../../context';
import { DailyrentPartnerButtonContainer } from '../AgentBookButtonContainer';
import { AgentPhoneButtonContainer } from '../AgentPhoneButtonContainer';
import { AgentShowMoreOffersContainer } from '../AgentShowMoreOffersContainer';
import { DailyrentOnlineBookingButtonContainer } from '../DailyrentOnlineBookingButtonContainer';
import { OfferChatButtonContainer } from '../OfferChatButtonContainer';
import { isCianPartner as isCianPartnerUtil } from 'shared/utils/dailyrent/isCianPartner';

export const DailyrentActionButtonsContainer = () => {
  const offerData = useOfferContext();
  const {
    offer: { dailyrent },
  } = offerData;
  const isDailyrentOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();
  const actionType = dailyrent?.actionType || EActionType.Contact;

  const isOnlineBookingActionType = [EActionType.OtaBooking, EActionType.OtaCheckDates].includes(actionType);
  const showOnlineBookingButtons = isDailyrentOnlineBookingEnabled && isOnlineBookingActionType;

  const isCianPartner = isCianPartnerUtil(offerData.offer);

  if (showOnlineBookingButtons) {
    return (
      <DailyrentActionsLayout>
        <AgentShowMoreOffersContainer />
        <DailyrentOnlineBookingButtonContainer />
        <OfferChatButtonContainer />
      </DailyrentActionsLayout>
    );
  }

  if (isCianPartner) {
    return (
      <DailyrentActionsLayout>
        <DailyrentPartnerButtonContainer />
      </DailyrentActionsLayout>
    );
  }

  return (
    <DailyrentActionsLayout>
      <AgentShowMoreOffersContainer />
      <AgentPhoneButtonContainer />
      <OfferChatButtonContainer />
    </DailyrentActionsLayout>
  );
};
